import { Link, Outlet, useLocation } from 'react-router-dom';
import { useUserRole } from '../../context/UserRoleContext';

const ORG_PATHS = ['/settings', '/settings/push-target', '/settings/llm', '/settings/git', '/settings/users'];

export default function SettingsLayout() {
  const { isAdmin } = useUserRole();
  const { pathname } = useLocation();
  const onOrgSide = ORG_PATHS.includes(pathname) || pathname.startsWith('/settings/projects');
  const onProfile = pathname === '/settings/profile' || pathname.startsWith('/settings/profile/');

  return (
    <div className="page settings-page">
      <div className="page-header">
        <div>
          <h1 className="page-title">Settings</h1>
          <p className="page-subtitle">
            {isAdmin ? 'Manage organisation settings, user access, and your personal preferences.' : 'Manage your personal preferences.'}
          </p>
        </div>
      </div>

      <div className="settings-tabs">
        <Link to="/settings" className={`settings-tab ${onOrgSide ? 'settings-tab-active' : ''}`}>
          Organisation Settings
        </Link>
        <Link to="/settings/profile" className={`settings-tab ${onProfile ? 'settings-tab-active' : ''}`}>
          My Settings
        </Link>
      </div>

      <Outlet />
    </div>
  );
}
